module.exports = __webpack_public_path__ + "img/venus.7ec8790f.svg";